import React__default from 'react';
import '../../node_modules/react-dnd/dist/esm/af597232e4287e1eccfc726dc727db9ba15b2b54007e8cfc25e30ca7416d66b5.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import styles from './911805e7d0f3f24d5c4539dfbcbf0ca9410ef311f2044b4b999baa91b0b8e88b.cfe-internal.js';
import { useDragLayer } from '../../node_modules/react-dnd/dist/esm/hooks/eea9dd777c0f3f73c618b874896caef57206ffbabdce95507ea78b535d3bb6d2.cfe-internal.js';
import Portal from '../../utils/Portal/021a1fdc9ca1735be9937767b2058e59614ca8e92028492bbc50e54e37b552ec.cfe-internal.js';

var AdvancedTableDragPreview = function AdvancedTableDragPreview(_ref) {
  var _columnHeaderRefs$ite, _tableRef$current;
  var tableRef = _ref.tableRef,
    columnHeaderRefs = _ref.columnHeaderRefs;
  var _useDragLayer = useDragLayer(function (monitor) {
      return {
        item: monitor.getItem(),
        currentOffset: monitor.getSourceClientOffset()
      };
    }),
    item = _useDragLayer.item,
    currentOffset = _useDragLayer.currentOffset;
  var width = columnHeaderRefs === null || columnHeaderRefs === void 0 || (_columnHeaderRefs$ite = columnHeaderRefs[item === null || item === void 0 ? void 0 : item.columnIndex]) === null || _columnHeaderRefs$ite === void 0 || (_columnHeaderRefs$ite = _columnHeaderRefs$ite.getBoundingClientRect()) === null || _columnHeaderRefs$ite === void 0 ? void 0 : _columnHeaderRefs$ite.width;
  var height = (_tableRef$current = tableRef.current) === null || _tableRef$current === void 0 || (_tableRef$current = _tableRef$current.getBoundingClientRect()) === null || _tableRef$current === void 0 ? void 0 : _tableRef$current.height;
  var top = (currentOffset === null || currentOffset === void 0 ? void 0 : currentOffset.y) || 0;
  var left = (currentOffset === null || currentOffset === void 0 ? void 0 : currentOffset.x) || 0;
  return /*#__PURE__*/React__default.createElement(Portal, null, /*#__PURE__*/React__default.createElement("div", {
    className: styles.dragPreview,
    style: {
      height: height,
      width: width,
      top: top,
      left: left
    }
  }));
};

export { AdvancedTableDragPreview as default };
